import React from 'react';
import { AlertTriangle, CheckCircle, ShieldAlert, XCircle, Clock } from 'lucide-react';
import { ApprovalTicket } from '../types';

interface SafeGuardModalProps {
  ticket: ApprovalTicket;
  onApprove: (ticketId: string, decision: 'APPROVE_ONCE' | 'ALLOW_SESSION' | 'REJECT') => void;
}

export const SafeGuardModal: React.FC<SafeGuardModalProps> = ({ ticket, onApprove }) => {
  const timeLeftSec = Math.max(0, Math.round((ticket.expiresAt - Date.now()) / 1000));

  const formatArgs = () => {
    try {
      return JSON.stringify(ticket.args, null, 2);
    } catch {
      return String(ticket.args);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <div className="modal-header">
          <div className="safeguard-icon" style={{ background: 'rgba(239, 68, 68, 0.25)' }}>
            <ShieldAlert size={28} />
          </div>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <h2 className="modal-title">SafeGuard Intercept Triggered</h2>
              <span className="danger-tag">{ticket.riskLevel} RISK</span>
            </div>
            <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem' }}>
              ChatGPT / Remote Agent is requesting a destructive operation that requires human approval.
            </p>
          </div>
        </div>

        <div style={{ background: 'rgba(239, 68, 68, 0.08)', border: '1px solid var(--border-danger)', borderRadius: 'var(--radius-md)', padding: '12px 16px' }}>
          <div style={{ fontWeight: 700, color: 'var(--accent-red)', fontSize: '0.9rem', marginBottom: '4px' }}>
            ⚠️ Intercept Reason:
          </div>
          <div style={{ color: 'var(--text-primary)', fontSize: '0.88rem' }}>
            {ticket.reason}
          </div>
        </div>

        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
            <span style={{ fontSize: '0.82rem', fontWeight: 600, color: 'var(--text-muted)' }}>
              TOOL: <strong style={{ color: 'var(--accent-cyan)' }}>{ticket.toolName}</strong>
            </span>
            <span style={{ fontSize: '0.82rem', color: 'var(--accent-amber)', display: 'flex', alignItems: 'center', gap: '4px' }}>
              <Clock size={14} /> Auto-expires in: {timeLeftSec}s
            </span>
          </div>
          <div className="code-preview-box">
            {formatArgs()}
          </div>
        </div>

        <div className="modal-actions">
          <button
            className="btn btn-secondary"
            onClick={() => onApprove(ticket.id, 'REJECT')}
          >
            <XCircle size={16} />
            Block & Reject
          </button>
          <button
            className="btn btn-success"
            style={{ background: '#0284c7' }}
            onClick={() => onApprove(ticket.id, 'ALLOW_SESSION')}
          >
            <Clock size={16} />
            Allow This Session (15m)
          </button>
          <button
            className="btn btn-success"
            onClick={() => onApprove(ticket.id, 'APPROVE_ONCE')}
          >
            <CheckCircle size={16} />
            Approve Once
          </button>
        </div>
      </div>
    </div>
  );
};
